module.exports = __webpack_public_path__ + "static/media/galway-2.943a1f7d.jpg";